import 'whatwg-fetch';
import 'raf/polyfill';
import 'core-js/fn/set';
import 'core-js/fn/map';
import 'core-js/fn/object/assign';
import 'core-js/fn/array/find';
import Promise from 'promise-polyfill';

if (!window.Promise) {
  window.Promise = Promise;
}



// WEBPACK FOOTER //
// ./src/main/ui/react/polyfills/src/index.js